import { createFileRoute, Navigate } from '@tanstack/react-router';

import { useWorkspace } from '@/app/context';
import { filterNav, PROJECT_NAV } from '@/app/navigation';

export const Route = createFileRoute('/_app/projects/$projectId/timeline/')({
  component: AreaIndex,
});

/** The first timeline tab this person may see. */
function AreaIndex() {
  const { projectId } = Route.useParams();
  const { nav } = useWorkspace();
  const first = filterNav(PROJECT_NAV, nav).find((item) => item.id === 'project.timeline')
    ?.children?.[0];
  return (
    <Navigate to={first?.to ?? '/projects/$projectId/overview'} params={{ projectId }} replace />
  );
}
